import {Component, Input} from '@angular/core';
import {AnnotationHandler} from '../../annotation-handler';
import {TranslatePipe} from "@ngx-translate/core";
import {FormsModule} from "@angular/forms";
import {NgClass} from "@angular/common";
import {MatTooltipModule} from "@angular/material/tooltip";

@Component({
    selector: 'app-annotation-description',
  imports: [
    TranslatePipe,
    FormsModule,
    MatTooltipModule,
    NgClass
  ],
    templateUrl: './annotation-description.component.html',
    styleUrls: ['./annotation-description.component.scss']
})
export class AnnotationDescriptionComponent {
  @Input() curAnn: AnnotationHandler;
  @Input() isDialog: boolean;
  private timeoutId;

  textChange(event: any) {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }

    this.timeoutId = setTimeout(() => {
      this.curAnn.selectedAnnotation.description = {
        description: event
      }

      this.curAnn.setDescription();
    }, 500);
  }
}
